import { createSelector } from "@reduxjs/toolkit";
import {
  berechneBondStrength,
  berechneUebertragungslaenge,
  berechneVerbundfestigkeit,
} from "../../../services/berechneTransmission";
import {
  selectDruckfestigkeitZement,
  selectPfahllaengeGewaehltInBoden,
  selectTeilsicherheitsbeiwertTransmission,
  selectVerbundbedingungenEta1,
} from "../aeussereSlice";
import { selectBemessungslast } from "../bemessungslastSlice";

export const selectVerbundfestigkeit = (traggliedDaten) => {
  return createSelector(
    [
      selectVerbundbedingungenEta1,
      selectDruckfestigkeitZement,
      selectTeilsicherheitsbeiwertTransmission,
    ],
    (verbundbedingungenEta1, druckfestigkeitZement, teilsicherheitsbeiwertTransmission) => {
      return berechneVerbundfestigkeit(
        verbundbedingungenEta1,
        traggliedDaten?.beiwert_eta2,
        druckfestigkeitZement,
        teilsicherheitsbeiwertTransmission
      );
    }
  );
};

export const selectUebertragungslaenge = (traggliedDaten) => {
  return createSelector(
    [selectBemessungslast, selectVerbundfestigkeit(traggliedDaten)],
    (bemessungslast, verbundfestigkeit) => {
      return berechneUebertragungslaenge(
        bemessungslast,
        Number(traggliedDaten?.durchmesser),
        verbundfestigkeit
      );
    }
  );
};

export const selectBondStrength = (traggliedDaten) => {
  return createSelector(
    [
      selectVerbundbedingungenEta1,
      selectDruckfestigkeitZement,
      selectTeilsicherheitsbeiwertTransmission,
    ],
    (verbundbedingungenEta1, druckfestigkeitZement, teilsicherheitsbeiwertTransmission) => {
      return berechneBondStrength(
        verbundbedingungenEta1,
        traggliedDaten?.beiwert_eta2,
        druckfestigkeitZement,
        teilsicherheitsbeiwertTransmission
      );
    }
  );
};

export const selectIsTransmissionLengthValid = (traggliedDaten) => {
  return createSelector(
    [selectUebertragungslaenge(traggliedDaten), selectPfahllaengeGewaehltInBoden],
    (uebertragungslaenge, pfahllaengeGewaehltInBoden) => {
      // Wenn die Übertragungslänge lb kleiner als die nominelle Länge des Einzelpfahls Lnom ist => Grün
      return uebertragungslaenge < pfahllaengeGewaehltInBoden;
    }
  );
};
